/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
// Place the currency symbol before the price.
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'TVNewsCheck',
    SITE_DESCRIPTION: 'TVNewsChecks',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/TVNewsCheck',
      twitter: 'https://x.com/TVNewsCheck',
      linkedin: 'https://www.linkedin.com/showcase/tvnewscheck/',
    },
    ASSETS: {
      logo: '/static/mediajobcenter/logo.png',
      faviconsPath: '/static/mediajobcenter',
    },
    OG_IMAGE: '/static/mediajobcenter/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#ce2a1e',
        secondary: '#525252',
      },
    },
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-2C26KLYSFJ', 'G-04SBN34ERZ'],
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: true,
  },
});
